import * as React from 'react';
import type { SVGProps } from 'react';
const SvgWrench = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 17 17"
    {...props}
  >
    <path
      fill="#4B7EFF"
      d="M15.844 4.688c.406 1.625-.094 3.375-1.281 4.562a4.74 4.74 0 0 1-4.47 1.281l-5.75 5.719c-.468.5-1.124.75-1.78.75-.688 0-1.344-.25-1.813-.75A2.43 2.43 0 0 1 0 14.469c0-.688.25-1.344.75-1.813l5.719-5.75c-.375-1.625.093-3.312 1.281-4.468 1.188-1.22 2.906-1.688 4.563-1.282.406.094.687.407.812.782.094.375 0 .78-.281 1.062L11 4.813l.156 1.03L12.187 6l1.844-1.844c.25-.25.656-.375 1.031-.25.407.094.688.406.782.781m-2.344 3.5c.656-.626 1-1.5 1-2.376l-1.812 1.813-2.813-.5-.469-2.812 1.781-1.782h-.03c-.876 0-1.72.313-2.344.969-.907.875-1.188 2.188-.782 3.406l.125.438-6.375 6.344a1.14 1.14 0 0 0-.281.78q0 .423.281.75c.407.376 1.125.376 1.532 0l6.343-6.374.438.156c1.219.375 2.531.094 3.406-.812M2.75 13.78c.25 0 .5.219.5.5 0 .25-.25.5-.5.5-.281 0-.5-.25-.5-.5 0-.281.219-.5.5-.5"
    />
  </svg>
);
export default SvgWrench;
